import type * as React from 'react';

import { useTranslation } from 'react-i18next';

import { dialogManager } from '../../../stores/DialogManager';
import { languageStore } from '../../../stores/LanguageStore';

import { cookieDialogStore } from '@egr/xbox/egr-gui-dialogs/cookieDialog/CookieDialogStore';

function withPreventDefault(callback: () => void): (event) => void {
  return (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    callback();
  };
}

export const useFooterLinks = () => {
  const { language } = languageStore.useState(['language']);
  const { t } = useTranslation();

  return [
    { href: `https://www.easterngraphics.com/${language}/`, label: '© EasternGraphics GmbH', id: 'mainLink' },
    { href: '', onClick: withPreventDefault(dialogManager.openLegalNotice), label: t('Legal notice'), id: 'legalNotice' },
    { href: '', onClick: withPreventDefault(dialogManager.openTermsOfUse), label: t('Terms of use'), id: 'termsOfUse' },
    { href: '', onClick: withPreventDefault(dialogManager.openDataPrivacy), label: t('Data privacy'), id: 'dataPrivacy' },
    {
      href: '',
      onClick: (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        void cookieDialogStore.waitForSubmit(true);
      },
      label: t('Cookie settings'),
      id: 'cookieSettings',
    },
    { href: `https://impress.wiki.pcon-solutions.com/doku.php?id=${language}:start`, label: t('FAQ'), id: 'FAQ' },
  ];
};
